import {BagSelectorProductGroup} from '@mfb/cookbook';

export const isExclusivelyServesOneGroup = (
  group: BagSelectorProductGroup
): boolean =>
  group.products.length > 0 && group.products.every(p => p.serves === 1);

export const getExclusivelyServesOneGroupNames = (
  groups: Array<BagSelectorProductGroup>
): Array<string> =>
  groups.filter(isExclusivelyServesOneGroup).map(g => g.productGroupName);

export const isExclusivelyServesOneCollection = (
  groups: Array<BagSelectorProductGroup>,
  collectionCode?: string
): boolean => {
  const group = groups.find(g => g.productGroupName === collectionCode);
  return group ? isExclusivelyServesOneGroup(group) : false;
};
